module.exports = __webpack_public_path__ + "img/heavy-lift.54751f7c.jpg";